import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    result: String,
    once: { type: Boolean, default: false }
  }

  connect() {
    const result = this.resultValue
    if (!result || result === "idle") return

    document.dispatchEvent(new CustomEvent("checkin:outcome", { detail: { result } }))

    if (this.onceValue) this.element.remove()
  }
}
